<template>
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </section>
</template>

  <script>
  export default {
    name: 'Main',
    computed: {
      key() {
        return this.$route.path
      }
    }
  }
  </script>
  <style lang="scss">
  .app-main {

}
</style>


// WEBPACK FOOTER //
// src/layout/components/main.vue